<script>
    export let value = [];
</script>

<div class="tags is-large">
    {#if value}
        {#each value as tag}
            <span class="tag is-{tag.color_class}">
                {tag.name}
            </span>
        {/each}
    {/if}
</div>